module.exports = __webpack_public_path__ + "media/images/icons/instagram-653199f66e2536541fd89c0a61f70156.svg";